import throttle from 'lodash.throttle';
import { useCallback, useEffect, useState } from 'react';
export const useAdaptiveRender = () => {
  const [loading, setLoading] = useState(true);
  const [width, setWidth] = useState((typeof window !== 'undefined' ? window : {}).innerWidth);
  const updateWidth = useCallback(throttle(() => setWidth((typeof window !== 'undefined' ? window : {}).innerWidth), 100), [width]);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setLoading(false);
      window.addEventListener('resize', updateWidth);
      return () => window.removeEventListener('resize', updateWidth);
    } else {
      return () => void 0;
    }
  }, []);
  return {
    width: width,
    loading: loading
  };
};
//# sourceMappingURL=index.js.map